import DrawSvg from "./DrawSvg.vue";

export default DrawSvg;
